import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  Image,
  Row,
  Modal,
  Col,
  Button,
  Form,
} from "react-bootstrap";
import Filter from "./../Filter";
import BasicPagination from "../../../Pagination/Pagination";
import ReactStars from "react-rating-stars-component";
import moment from "moment";
import isEmpty from "../../../../store/validation/is-Empty";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { RatingReviewTablebody } from "./RatingReviewTablebody";
import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import { MobileSeatingReviewTable } from "../MobileSeatingReviewTable";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const Seating = (props) => {
  const [seatingData, setSeatingData] = useState([]);
  useEffect(() => {
    setSeatingData(props.seatingReview);
  }, [props.seatingReview]);

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(25);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 25 - 25;
    setStart(calcStart);
    setEnd(pageNo * 25);
    setPage(pageNo);
  };

  const [state, setState] = useState({
    open: false,
    ratingChecked: true,
    serviceChecked: false,
    search: "",
    tempCount: 0,
    ratingCount: 0,
    totalRecordsInOnePage: 25,
    currentPagination: 1,
  });

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const openModal = (e) => {
    setState({
      ...state,
      open: true,
    });
  };

  const fillerClick = (type) => (e) => {
    setState({
      ...state,
      tempCount: type,
    });
  };

  const handleResetClick = () => (e) => {
    setState({
      ...state,
      ratingCount: 0,
      tempCount: 0,
    });
  };

  const handleCloseModal = (e) => {
    setState({
      ...state,
      ratingCount: state.tempCount,
      open: false,
    });
  };

  const handleCheckedRating = (e) => {
    setState({
      ...state,
      ratingChecked: !state.ratingChecked,
      serviceChecked: !state.serviceChecked,
    });
  };
  // const handleCheckedService = (e) => {
  //   setState({
  //     ...state,
  //     ratingChecked: true,
  //     serviceChecked: false,
  //   });
  // };

  const renderSeatingReview = () => {
    const allIssuesDetails = seatingData;
    let filtereddata = [];
    if (state.ratingCount === 0) {
      filtereddata = allIssuesDetails;
    } else if (state.ratingCount === 1) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 0 && data.rating < 2
      );
    } else if (state.ratingCount === 2) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 2 && data.rating < 3
      );
    } else if (state.ratingCount === 3) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 3 && data.rating < 4
      );
    } else if (state.ratingCount === 4) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 4 && data.rating < 5
      );
    } else if (state.ratingCount === 5) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating === 5
      );
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filtereddata = allIssuesDetails.filter((getall) => {
        if (
          search.test(
            getall.user_id &&
              getall.user_id.first_name + " " + getall.user_id.last_name
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    // else {
    //   filtereddata = seatingData;
    // }
    if (!isEmpty(filtereddata)) {
      return filtereddata.slice(start, end).map((data, index) => (
        // index >=
        //   (state.currentPagination - 1) * state.totalRecordsInOnePage &&
        // index < state.currentPagination * state.totalRecordsInOnePage && (
        // <tbody key={index}>
        //   <tr className="super_admin_all_users_table_body">

        //   </tr>
        // </tbody>
        <React.Fragment key={index}>
          <RatingReviewTablebody
            data={data}
            selectedValue={props.selectedValue}
          />
        </React.Fragment>
      ));
      // );
    } else {
      return null;
    }
  };

  const renderMobileSeatingReview = () => {
    const allIssuesDetails = seatingData;
    let filtereddata = [];
    if (state.ratingCount === 0) {
      filtereddata = allIssuesDetails;
    } else if (state.ratingCount === 1) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 0 && data.rating < 2
      );
    } else if (state.ratingCount === 2) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 2 && data.rating < 3
      );
    } else if (state.ratingCount === 3) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 3 && data.rating < 4
      );
    } else if (state.ratingCount === 4) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating >= 4 && data.rating < 5
      );
    } else if (state.ratingCount === 5) {
      filtereddata = allIssuesDetails.filter(
        (data) => data && data.rating === 5
      );
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filtereddata = allIssuesDetails.filter((getall) => {
        if (
          search.test(
            getall.user_id &&
              getall.user_id.first_name + " " + getall.user_id.last_name
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    // else {
    //   filtereddata = seatingData;
    // }
    if (!isEmpty(filtereddata)) {
      return filtereddata
        .slice(start, end)
        .map((data, index) => (
          <MobileSeatingReviewTable
            data={data}
            selectedValue={props.selectedValue}
            indexKey={index}
          />
        ));
    } else {
      return null;
    }
  };

  return (
    <React.Fragment>
      <Media query="(min-width: 992px)">
        <Row className="align-items-center pt-4">
          <Col className="col-auto seating-topbar-search">
            <div className="filter-button">
              <Filter
                onHendleClick={fillerClick}
                handleCloseModal={handleCloseModal}
                open={state.open}
                onOpenModal={openModal}
                handleReset={handleResetClick}
                ratingChecked={state.ratingChecked}
                serviceChecked={state.serviceChecked}
                ratingCheckedClick={handleCheckedRating}
              />
            </div>
          </Col>
          <Col md={4}>
            <Form.Control
              type="text"
              placeholder="Search"
              className="amSearch"
              name="search"
              onChange={onChange}
              value={state.search}
            />
          </Col>
        </Row>
      </Media>
      <Media query="(max-width: 992px)">
        <Container className="d-mobile-flex">
          <Row className="align-items-center pt-4 ">
            <Col xs={3} className="col-3 seating-topbar-search">
              <div className="filter-button">
                <Filter
                  onHendleClick={fillerClick}
                  handleCloseModal={handleCloseModal}
                  open={state.open}
                  onOpenModal={openModal}
                  handleReset={handleResetClick}
                  ratingChecked={state.ratingChecked}
                  serviceChecked={state.serviceChecked}
                  ratingCheckedClick={handleCheckedRating}
                />
              </div>
            </Col>
            {/* <Col xs={1} /> */}
            <Col xs={8} style={{ marginLeft: "10px" }}>
              <Form.Control
                type="text"
                placeholder="Search"
                className="amSearch"
                name="search"
                onChange={onChange}
                value={state.search}
              />
            </Col>
          </Row>
        </Container>
      </Media>
      <Media query="(min-width: 992px)">
        <div className="user-table-reusable-superadmin table-responsive">
          <Table className="enMinWidth900 w-100">
            <thead>
              <tr className="super_admin_all_users_table_head">
                <th
                  className="f12-700"
                  style={{
                    width: `${
                      props.selectedValue === "4" || props.selectedValue === "2"
                        ? "18%"
                        : "20%"
                    }`,
                  }}
                >
                  User Name
                </th>
                {props.selectedValue === "4" || props.selectedValue === "2" ? (
                  <th
                    className="f12-700"
                    style={{
                      width: `${
                        props.selectedValue === "4" ||
                        props.selectedValue === "2"
                          ? "18%"
                          : "20%"
                      }`,
                    }}
                  >
                    {props.selectedValue === "2" ? "Event" : "Item Name"}
                  </th>
                ) : null}
                <th
                  className="f12-700"
                  style={{
                    width: `${
                      props.selectedValue === "4" || props.selectedValue === "2"
                        ? "15%"
                        : "20%"
                    }`,
                  }}
                >
                  Ratings-
                  <br />
                  Date & Time
                </th>
                <th
                  className="f12-700"
                  style={{
                    width: `${
                      props.selectedValue === "4" || props.selectedValue === "2"
                        ? "31%"
                        : props.selectedValue === "0"
                        ? "60%"
                        : props.selectedValue === "1"
                        ? "40%"
                        : props.selectedValue === "3"
                        ? "40%"
                        : "20%"
                    }`,
                  }}
                >
                  Review / Comment
                </th>
                {props.selectedValue === "0" ? null : (
                  <th
                    className="f12-700"
                    style={{
                      width: `${
                        props.selectedValue === "4" ||
                        props.selectedValue === "2"
                          ? "18%"
                          : "20%"
                      }`,
                    }}
                  >
                    Request Type /<br />
                    Request Number
                  </th>
                )}
              </tr>
            </thead>
            {renderSeatingReview()}
          </Table>
          <div className="col-12">
            <BasicPagination
              totalRecords={seatingData.length}
              limit={25}
              batch={page}
              onBatchChange={(e) => handleBatchChange(e)}
            />
          </div>
        </div>
      </Media>
      <Media query="(max-width: 992px)">
        <Container>
          <div className="row seating-dashboard-table">
            <div className="col-4  mpl-1  mpr-1">
              <center>
                <p className="f12-500">
                  User
                  <br /> Name
                </p>
              </center>
            </div>
            {props.selectedValue === "4" || props.selectedValue === "2" ? (
              <div
                className="col-3  mpl-1 mpr-2 f10-700 mpr-1"
                style={{
                  width: `${
                    props.selectedValue === "4" || props.selectedValue === "2"
                      ? "10%"
                      : "12%"
                  }`,
                }}
              >
                <p>{props.selectedValue === "2" ? "Event" : "Item Name"}</p>
              </div>
            ) : null}
            <div
              className="col-4 mpl-1 mpr-2"
              style={{
                width: `${
                  props.selectedValue === "4" || props.selectedValue === "2"
                    ? "8%"
                    : "8%"
                }`,
              }}
            >
              <center>
                {" "}
                <p className="f12-500">
                  Ratings-
                  <br />
                  Date & Time
                </p>
              </center>
            </div>
            {props.selectedValue === "2" &&
            props.selectedValue === "5" ? null : (
              <div
                className="col-4 mpl-1"
                style={{
                  width: `${
                    props.selectedValue === "4" || props.selectedValue === "2"
                      ? "9%"
                      : props.selectedValue === "0"
                      ? "9%"
                      : props.selectedValue === "1"
                      ? "9%"
                      : props.selectedValue === "3"
                      ? "9%"
                      : "9%"
                  }`,
                }}
              >
                <center>
                  <p className="f12-500">
                    Review /<br /> Comment
                  </p>
                </center>
              </div>
            )}
            {/* {props.selectedValue === "0" && props.selectedValue === "1" ? null : (
            <div
              className="col-4 mpl-1 f12-700"
              style={{
                width: `${
                  props.selectedValue === "4" || props.selectedValue === "2"
                    ? "9%"
                    : "9%"
                }`,
              }}
            >
              <center>Request Type /<br />
              Request Number</center>
            </div>
          )} */}
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <Accordion>{renderMobileSeatingReview()}</Accordion>
            </div>
            <div className="col-12">
              <BasicPagination
                totalRecords={seatingData.length}
                limit={25}
                batch={page}
                onBatchChange={(e) => handleBatchChange(e)}
              />
            </div>
          </div>
        </Container>
      </Media>
    </React.Fragment>
  );
};

export default Seating;
